import axios from "axios";
import configData from "../config";
import { store } from "../store";
import { demoRegistry } from "./demoData/demoRegistry";
import { getAuthTokenByUrl } from "./systemTokenRegistry";

export const apiGet = async (urlOrConfig, options = {}) => {
    const url =
        typeof urlOrConfig === "string"
            ? urlOrConfig
            : urlOrConfig?.url;

    const params =
        typeof urlOrConfig === "string"
            ? options.params || {}
            : urlOrConfig?.params || {};

    if (!url) throw new Error("apiGet: URL is required");

    const { account } = store.getState();
    const user_role = Number(account?.user_role);

    // 🟡 DEMO USER → try demo handler
    if (user_role === 6) {

        const demoHandler = demoRegistry[url];
        if (demoHandler) {
            console.log(`🟡 DEMO DATA → ${url}`);
            return Promise.resolve({
                data: demoHandler(params),
            });
        }

        console.log(`🟢 DEMO USER FALLBACK TO REAL API → ${url}`);
    }

    //  Resolve token using system registry
    const token = getAuthTokenByUrl(url, account);

    // 🟢 NORMAL USER OR FALLBACK
    return axios.get(`${configData.API_SERVER}${url}`, {
        headers: {
            Authorization: token ? `Bearer ${token}` : undefined,
        },
        params,
    });
};
